import { useTranslation } from "react-i18next";
import ThreeDotLoader from '@shared/components/ThreeDotLoader';
import useInfiniteScroll from '@shared/hooks/useInfiniteScroll';

const InfiniteScrollTrigger = ({ 
  isFetchingNextPage, 
  hasNextPage, 
  fetchNextPage,
  threshold = 0.1,
  rootMargin = '100px'
}) => {
  const { t } = useTranslation();
  const { triggerRef } = useInfiniteScroll({
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    threshold,
    rootMargin
  });

  return (
    <div 
      ref={triggerRef}
      className="flex items-center justify-center min-h-[60px] mt-4"
    >
      {isFetchingNextPage ? (
        <div className="flex items-center gap-2">
          <ThreeDotLoader size="sm" color="primary" />
          <span className="text-sm text-muted-foreground">
            {t("infiniteScroll.loading", "Loading more...")}
          </span>
        </div>
      ) : hasNextPage ? (
        <div className="text-sm text-muted-foreground opacity-50">
          {t("infiniteScroll.scrollForMore", "Scroll down for more")}
        </div>
      ) : (
        <div className="text-sm text-muted-foreground">
          {t("loadMoreButton.noMoreData")}
        </div>
      )}
    </div>
  );
};

export default InfiniteScrollTrigger;
